// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ImageCard_wrapper__3n572","imageWrapper":"ImageCard_imageWrapper__L2Njc"};